module.exports = __webpack_public_path__ + "static/media/Lesson-4-23-Walk-by-the-Spirit-and-Live.9941b103.pdf";